export enum HistoryDialog {
    UNDO = 'undo',
    REPEAT = 'repeat',
    SETTINGS = 'settings'
}
